import HttpService from '../services/http-service';

export default () => {
  return HttpService.get({ url: '/version' });
};
